import React from 'react';
import '../styles/WeeklySummary.css';

function getThisWeekWins(wins) {
  const startOfWeek = new Date();
  startOfWeek.setHours(0, 0, 0, 0);
  startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
  return wins.filter((w) => w.created && new Date(w.created) >= startOfWeek);
}

function formatMinutes(totalMinutes) {
  const h = Math.floor(totalMinutes / 60);
  const m = Math.round(totalMinutes % 60);
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

export default function WeeklySummary({ wins }) {
  const weekWins = getThisWeekWins(wins);

  const weeklyOrgMinutes = wins.reduce((sum, w) => {
    const mins = w.timeSavedMinutes || 0;
    if (w.frequency === 'One-time') return sum + mins / 26;
    if (w.frequency === 'Daily') return sum + mins * 5;
    if (w.frequency === 'Weekly') return sum + mins;
    if (w.frequency === 'Monthly') return sum + mins / 4.35;
    return sum;
  }, 0);

  return (
    <div className="weekly-summary">
      <div className="summary-stat">
        <span className="summary-value">{formatMinutes(weeklyOrgMinutes)}</span>
        <span className="summary-label">Weekly Org Capacity Added</span>
      </div>
      <div className="summary-divider" />
      <div className="summary-stat">
        <span className="summary-value">{weekWins.length}</span>
        <span className="summary-label">Wins Submitted This Week</span>
      </div>
      <div className="summary-divider" />
      <div className="summary-stat">
        <span className="summary-value">{wins.length}</span>
        <span className="summary-label">Total Wins</span>
      </div>
    </div>
  );
}
